export enum SubjectStatus {
	Active = 1,
	Canceled = 2,
}
